import React from 'react'
import { logo } from '../constants/files'

const Error = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center px-3" style={{ backgroundColor: "#000", color: "#f8f9fa" }}>
            <img src={logo} alt="Company Logo" className="mb-4" style={{ height: "60px" }} />
            <i className="text-danger mb-3 fa fa-exclamation-circle fs-1" />
            <h1 className="fw-bold">Oops! Une erreur s'est produite</h1>
            <p className="text-light">
                Un problème est survenu. Veuillez réessayer ou revenir plus tard.
            </p>
            <a href="/" className=" bgcolor-primary px-4 py-2 rounded-pill">
                <span className='text-white'>Retour à l'accueil</span>
            </a>
        </div>
    )
}

export default Error